<template>
	<div>
		<router-view></router-view>
	</div>
</template>

<script>
export default {
	name: 'page-recruitment',
};
</script>



// WEBPACK FOOTER //
// src/modules/recruitment/pages/page-recruitment.vue